import { useQuery } from '@tanstack/react-query';
import { getDismissedVsResolved } from '../services/AnalyticReportsService';
export default function useDismissedVsResolved(filters) {
    return useQuery(['dismissedVsResolved', filters.values.dateRange], () => getDismissedVsResolved(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
